module.exports = __webpack_public_path__ + "img/white-paper.25f824b3.jpg";